import { AspectRatio } from "@components/core/AspectRatio";
import DepthScroller from "@components/core/DepthScroller";
import ChevronRight16 from "@ui/icons/16x16/chevron-right-16.svg";
import { Fragment } from "react";

import { asset, config } from "./config";

export default function DubbingHero() {
  const items = config.map(item => <Item key={item.cover} {...item} />);
  return <DepthScroller asset={<Asset />} items={items} />;
}

function Item({ cover, languages }: { cover: string; languages: React.ReactNode[] }) {
  return (
    <div className='relative h-full w-[200px] overflow-hidden rounded-lg md:w-[350px] md:rounded-xl'>
      <AspectRatio ratio='16x9' rounded={false}>
        <img alt='A screenshot of a video dubbed by Elevenlabs' className='h-full w-full object-cover' src={cover} />
      </AspectRatio>
      <div className='absolute left-0 top-0 h-full w-full bg-gradient-to-b from-transparent to-[rgba(0,0,0,.4)]' />
      <div className='absolute bottom-10 left-10 flex items-center gap-6 rounded-full bg-default p-8 md:bottom-16 md:left-16'>
        {languages.map((language, i) => {
          return (
            <Fragment key={`language-${i}`}>
              {language}
              {i === 0 ? <ChevronRight16 /> : null}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}

function Asset() {
  return (
    <div
      className='overflow-hidden rounded-md shadow-[0px_0px_32px_rgba(0,0,0,0.16)] md:rounded-lg md:shadow-[0px_0px_48px_rgba(0,0,0,0.16)]'
      style={{ backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}
    >
      <img alt='A screenshot of the ElevenLabs Dubbing UI' className='h-full w-full opacity-90' src={asset} />
    </div>
  );
}
